// extracted by mini-css-extract-plugin
export var icon = "_77-1";
export var subtext = "_77-0";